/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React from "react";
import AccessibilityCss from "components/accessibility/Accessibility.css";
import { useRefToSetFocus } from "containers/accessibility/AccessibleFocusableNodeContainers";
import { a11yClasses } from "constants/enums";

export const AccessibleLinkNode = ({ onClick, onFocus, style, shouldFocus, textContent, resetShouldFocus }) => {
  const ref = useRefToSetFocus(shouldFocus, resetShouldFocus);
  return (
    <button
      role="link"
      onClick={onClick}
      style={style}
      className={`${AccessibilityCss.linkNode} ${a11yClasses.A11Y_LINK}`}
      onFocus={onFocus}
      ref={ref}
    >
      {textContent}
    </button>
  );
};

export const PlainLinkNode = ({ style, textContent, linkInfo }) => (
  <a style={style} href={(linkInfo && linkInfo.linkUri) || "#"}>
    {textContent}
  </a>
);
